import { NewsData } from "../dashboardOverview.types";
import { DashboardCard } from "./DashboardCard";
import { NewsIcon } from "./DashboardIcons";

export interface NewsUpdatesCardProps {
	data: NewsData;
	onViewAll?: () => void;
	onSelectItem?: (href: string) => void;
}

// ===== CHANGED: renamed "View all news" → "All updates", tag + date now
// sit on one line, description is optional, and a title with an `href`
// renders as a link (copy this whole file) =====
export const NewsUpdatesCard = ({ data, onViewAll, onSelectItem }: NewsUpdatesCardProps) => {
	return (
		<DashboardCard className="cd-news-card" testId="news-updates-card">
			<div className="cd-card__header">
				<div className="cd-card__title">
					<NewsIcon />
					<h2>Payroll news</h2>
				</div>
				<button type="button" className="cd-link-button" onClick={onViewAll}>
					All updates
				</button>
			</div>

			{data.items.length === 0 ? (
				<div className="cd-notifications-empty">
					<NewsIcon className="cd-icon--muted" />
					<span>No news or updates right now</span>
				</div>
			) : (
				<div className="cd-news-list">
					{data.items.map((item) => (
						<div className="cd-news-list__item" key={item.id}>
							<div className="cd-news-list__meta-row">
								<span className="cd-news-tag">{item.tag}</span>
								<span className="cd-news-list__date">{item.dateLabel}</span>
							</div>
							{item.href ? (
								<button
									type="button"
									className="cd-news-list__title cd-news-list__title--link"
									onClick={() => onSelectItem?.(item.href as string)}
								>
									{item.title}
								</button>
							) : (
								<div className="cd-news-list__title">{item.title}</div>
							)}
							{item.description && <div className="cd-news-list__description">{item.description}</div>}
						</div>
					))}
				</div>
			)}
		</DashboardCard>
	);
};
